import React, { memo, useState, useCallback } from '../../lib/teact/teact';
import Icon from './icons/Icon';
import styles from './LarpersLanding.module.scss';
import { 
  AnalyticsMockupCard,
  AuditMockupCard,
  DraggablePillMockup,
  AdminBadgeMockup,
  BotBadgeMockup,
  MockupTokenPill
} from './larpers/LarpersLandingFeatures';
import PwaInstallModal from './larpers/PwaInstallModal';
import { IS_PWA, IS_IOS, IS_ANDROID } from '../../util/browser/windowEnvironment';

const ExclusiveBetaCard = memo(() => {
  return (
    <div className={styles.betaCardWrapper}>
      <div className={styles.betaCard}>
        <div className={styles.betaHeader}>
          <div className={styles.betaLiveIndicator}>
            <div className={styles.liveDot} />
            <span>Private Beta</span>
          </div>
          <span className={styles.betaSpots}>10-20 Users Only</span>
        </div>
        <h3 className={styles.betaTitle}>Exclusive Access</h3>
        <p className={styles.betaDesc}>We are in beta testing right now. Access is highly restricted and only available to a select few.</p>
        <div className={styles.betaProgressBar}>
          <div className={styles.betaProgressFill} style="width: 95%" />
        </div>
        <span className={styles.betaProgressText}>Capacity almost full</span>
      </div>
    </div>
  );
});

const PwaInstallCard = memo(() => {
  return (
    <div className={styles.installReminderWrapper}>
      <div className={styles.installReminder}>
        <div className={styles.installIconRow}>
           <div className={styles.installStepIcon}>
             <Icon name="share-filled" />
           </div>
           <div className={styles.installArrow}>➔</div>
           <div className={styles.installStepIcon}>
             <Icon name="add" />
           </div>
        </div>
        <h3 className={styles.installReminderTitle}>Ready to start?</h3>
        <p className={styles.installReminderText}>
          To use Larpers, please add this website to your home screen.<br />
          Simply tap the <strong>Share</strong> button (iOS) or <strong>3 dots</strong> (Android) and select <strong>Add to Home Screen</strong>.
        </p>
      </div>
    </div>
  );
});

const LarpersLanding = () => {
  const [isInstallModalOpen, setIsInstallModalOpen] = useState(!IS_PWA && (IS_IOS || IS_ANDROID));

  const handleCloseInstallModal = useCallback(() => {
    setIsInstallModalOpen(false);
  }, []);
  return (
    <div className={styles.page}>
      <div className={styles.mobileContainer}>
        {/* 1. TOP VIDEO SECTION */}
        <div className={styles.videoWrapper}>
        <video
          className={styles.heroVideo}
          src="intro.mp4"
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
        />
      </div>

      {/* 2. MAIN BOTTOM WINDOW */}
      <div className={styles.bottomWindow}>
        {/* 3. 13% PILL CARD */}
        <div className={styles.mockupPillCard}>
          <div className={styles.dragHandle} />
          <div className={styles.headerMain}>
            <div className={styles.logoWrapper}>
              <img
                className={styles.avatarImage}
                src="pill-logo.png"
                alt="Pepe"
              />
            </div>

            <div className={styles.infoCol}>
              <div className={styles.titleRow}>
                <span className={styles.name}>Pepe</span>
                <span className={styles.ticker}>$PEPE</span>
                <button
                  type="button"
                  className={styles.copyBtn}
                  title="Copy Address"
                  aria-label="Copy Address"
                >
                  <Icon name="copy" className={styles.copyIcon} />
                </button>
              </div>

              <div className={styles.linksRow}>
                <div className={styles.ageBadge}>
                  <Icon name="clock" className={styles.ageIcon} />
                  <span>1d 45m</span>
                </div>

                <div className={styles.socialIcons}>
                  <a className={styles.socialLink} title="Website">
                    <Icon name="web" className={styles.socialIcon} />
                  </a>
                  <a className={styles.socialLink} title="X (Twitter)">
                    <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" className={styles.xIcon}>
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                  </a>
                  <a className={styles.socialLink} title="Telegram">
                    <Icon name="channel" className={styles.socialIcon} />
                  </a>
                </div>
              </div>
            </div>

            <div className={styles.mcapCol}>
              <div className={styles.mcapValueWrapper}>
                <span className={styles.mcapLabel}>MCAP</span>
                <span className={styles.mcapValue}>$13.7K</span>
              </div>
              <div className={styles.quickBuyRow}>
                <button type="button" className={styles.quickBuyBtn}>Buy 0.01</button>
                <button type="button" className={styles.quickBuyBtn}>Buy 0.015</button>
              </div>
            </div>
          </div>
        </div>
        
        {/* NEW SCROLLABLE CONTENT */}
        <div className={styles.scrollContent}>
          
          <div className={styles.messageBubble}>
            <p className={styles.messageText}>Guys i feel this can moon</p>
            <div className={styles.messagePillWrapper}>
              <MockupTokenPill />
            </div>
            
            {/* Telegram Message Meta (Time + Double Checkmarks) */}
            <div className={styles.messageMeta}>
              <span className={styles.messageTime}>03:02</span>
              <span className={styles.messageChecks}>
                <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.875 3.5l-4.75 4.75-2.25-2.25L2.8125 7l3.3125 3.3125 5.8125-5.8125-1.0625-1z M14.125 3.5l-4.75 4.75-0.75-0.75 1.0625-1.0625 3.375-3.375 1.0625 1.0625z" fill="currentColor" />
                  <path d="M9.375 8.25l-0.5625 0.5625 1.5 1.5 5.8125-5.8125-1.0625-1.0625-4.75 4.75-0.9375-0.9375z" fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>

          <div className={styles.tagline}>NATIVE TELEGRAM INTEGRATION</div>
          <h2 className={styles.heroHeading}>Larpers App</h2>
          <p className={styles.description}>
            The fastest and most secure way to trade on Telegram. Built IN buttery-smooth, native UI for millisecond-live token data, instant one-tap buys, and monitor the coins/dev with your friends, without ever switching apps.
          </p>

          <div className={styles.featuresGrid}>
            <AnalyticsMockupCard />
            
            <div className={styles.featureBlock}>
              <h2 className={styles.featureHeading}>First Larper</h2>
              <p className={styles.description}>
                See who actually caught the bottom. We expose the first larper of any coin when they called it, the exact mcap, and if their shill actually drove volume. Track every ATH and dip since the call to see if your friends are printing or coping.
              </p>
            </div>

            <div className={styles.featureBlock}>
              <h2 className={styles.featureHeading}>Dev Larp Capability</h2>
              <p className={styles.description}>
                Decode the dev's entire larping playbook. We scan every coin they've pushed to find their average peak mcap and exactly how many hours it takes them to hit ATH. See if they instant dump or slow bleed their bags so you can out larp them and perfectly time your exit.
              </p>
            </div>

            <AuditMockupCard />
            
            <div className={styles.featureBlock}>
              <h2 className={styles.featureHeading}>Deep Audit & Bundle Tracking</h2>
              <p className={styles.description}>
                Visualize token distribution instantly with our native Telegram dashboard. See exact what sniper and bundler doing Live, and verify safety audits like Dex paid and renounced contracts in a single glance before making your move.
              </p>
            </div>

            {/* Draggable Pill Feature */}
            <div className={styles.pillFeatureContainer}>
              <div className={styles.pillMockupSide}>
                <DraggablePillMockup />
              </div>
              <div className={styles.pillTextSide}>
                <h2 className={styles.pillFeatureHeading}>Swipe to Sell</h2>
                <p className={styles.pillFeatureDesc}>
                  Stop fumbling through menus when you need to exit fast. Our native draggable pill sits right on your screen. Just drag down to snap 25%, 50%, 75%, or 100% of your bag and release to sell instantly. Hear the haptic click and secure your gains in milliseconds.
                </p>
              </div>
            </div>

            {/* Admin Badge Feature */}
            <AdminBadgeMockup />
            <div className={styles.featureBlock}>
              <h2 className={styles.featureHeading}>Track Key Players</h2>
              <p className={styles.description}>
                Know exactly what the project team and important people are doing. Filter the noise and easily track if the devs are actually alive, building, or if they've left the chat.
              </p>
            </div>

            {/* Bot Badge Feature */}
            <BotBadgeMockup />
            <div className={styles.featureBlock}>
              <h2 className={styles.featureHeading}>Banish the Bots</h2>
              <p className={styles.description}>
                We all miss the old non-bot days. Now every chat is spammed by 10 bots dumping the same ugly, slow data. Our native UI fixes this. Hide the spam and keep your feed clean.
              </p>
            </div>

            </div>

          <PwaInstallCard />

          {/* Big Tech Footer */}
          <footer className={styles.footerContainer}>
            <div className={styles.footerBrand}>
              <div className={styles.footerLogoWrapper}>
                <img src="app-logo.png" alt="Larpers App" className={styles.footerLogo} />
                <span className={styles.footerAppName}>Larpers</span>
              </div>
              <p className={styles.footerBrandDesc}>The fastest native way to trade visually on Telegram.</p>
            </div>
            
            <div className={styles.footerActions}>
              <div className={styles.footerSocials}>
                <a href="#" className={styles.footerSocialLink}>Twitter/X</a>
                <a href="#" className={styles.footerSocialLink}>Telegram</a>
              </div>
              <span className={styles.footerCopyright}>© 2026 Larpers Inc. All rights reserved.</span>
            </div>
          </footer>
        </div>
      </div>
      </div>
      
      <PwaInstallModal 
        isOpen={isInstallModalOpen} 
        onClose={handleCloseInstallModal} 
      />
    </div>
  );
};

export default memo(LarpersLanding);
